import { useTranslation } from "react-i18next";

import { Text } from "chameleon/lib/components";

import { ApplePayButton } from "checkout-experience/components/payment-method/pay-options/apple/apple-pay-button";
import { PaymentDomain } from "checkout-query-client/api/types";

interface ApplePayProps {
  paymentDomain?: PaymentDomain;
}

export const ApplePay = ({ paymentDomain }: ApplePayProps) => {
  const { t } = useTranslation(["combined"]);

  return (
    <>
      <Text styleVariant="caption" colorVariant="primaryText">
        {t("applePay.messageReviewLine1")}
      </Text>
      <Text styleVariant="caption" colorVariant="primaryText">
        {t("applePay.messageReviewLine2")}
      </Text>
      {/* TODO: replace Privacy Policy and ToS below with actual links */}
      <Text styleVariant="caption" colorVariant="secondaryText">
        {t("applePay.messageReviewLine3")}
      </Text>
      <ApplePayButton paymentDomain={paymentDomain} />
    </>
  );
};
